import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useFetcher from "@/utils/use-fetcher";

export interface DeleteShippingInfoPathParameter {
  companyId: number;
  shippingInfoId: number;
}

export const deleteShippingInfoTemplateUrl =
  "/buyers/:companyId/shipping-infos/:shippingInfoId";

export const deleteShippingInfoKey: YWRKey<DeleteShippingInfoPathParameter> = {
  url: (parameter) => calcUrl(deleteShippingInfoTemplateUrl, parameter),
  method: "delete",
};

export default function useDeleteShippingInfo() {
  const fetcher = useFetcher<{}, {}>();
  return useYWR(deleteShippingInfoKey, fetcher);
}
